import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CtaButton } from '../CtaButton';
import { gluteProduct } from '../../data/gluteCopy';
export function GluteStickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 700);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-173" data-mp="2mrd5jf47j52t">
      {visible && <motion.div initial={{
      y: 90,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 90,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-50 border-t border-coal-line bg-coal-deep/95 px-4 py-3 backdrop-blur" data-id="element-174" data-mp="2moh5nl8su6bq">
          <div className="mx-auto flex w-full max-w-3xl items-center gap-4" data-id="element-175" data-mp="2334bezj3sp0o">
            <p className="hidden shrink-0 text-[0.8rem] leading-tight text-white/50 sm:block" data-id="element-176" data-mp="28r5vah6e7hwf">
              Guía completa
              <span className="block text-sm font-semibold text-white" data-id="element-177" data-mp="2dppg2e992nn7">
                ${gluteProduct.guidePrice.toFixed(2)} pago único
              </span>
            </p>
            <CtaButton tone="ember" label="¡QUIERO DESPERTAR MIS GLÚTEOS AHORA!" scrollToId="precio-glute" className="flex-1" data-id="element-178" data-mp="2ng2cp4uca79p" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}